import React from 'react';
import { Checkbox, Form } from 'antd';
import Text from 'components/Text/Text';
import style from './IsRestrictedCheckbox.module.scss';

interface IProps {
	toggleIsRestricted: () => void;
	isRestricted: boolean;
	isDisabled: boolean;
}

export const IsRestrictedCheckbox: React.FC<IProps> = React.memo(({ toggleIsRestricted, isRestricted, isDisabled }) => {
	return (
		<Form.Item className={style.container} name="isRestricted" data-test="IsRestrictedCheckbox">
			<Checkbox onChange={toggleIsRestricted} checked={isRestricted} disabled={isDisabled}>
				<Text translationNameSpace="form" translationKey="isRestrictedLabel" asFragment={true} />
			</Checkbox>
		</Form.Item>
	);
});
